/* NJL Studio */


document.addEventListener("DOMContentLoaded", function() {

      function scrollToElementById(id) {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
        
        // Check if URL contains '#lymphatic-drainage-massage' on page load
        window.addEventListener('load', () => {
            const hash = window.location.hash;
            if (hash === '#lymphatic-drainage-massage') {
                scrollToElementById('lymphatic-drainage-massage');
            }
        });
  
      const BotanicalItems = document.querySelectorAll('.multi-column__item.expandable');

        BotanicalItems.forEach(item => {
            item.addEventListener('click', () => {
              console.log(event.target.classList);
                const accordion = item.querySelector('.accordion.group');

                if (accordion) {
                  if (!event.target.classList.contains('read-more') && !event.target.classList.contains('read-less') && !event.target.classList.contains('accordion__toggle')) {
               
                    const isExpanded = accordion.getAttribute('aria-expanded') === 'true';
                    
                    if (isExpanded) {
                        accordion.setAttribute('aria-expanded', 'false');
                        accordion.removeAttribute('open');
                    } else {
                        accordion.setAttribute('aria-expanded', 'true');
                        accordion.setAttribute('open', '');
                    }
                  }
            }
            });
        });
  
        document.querySelectorAll('.description-block .full').forEach(function(element) {
          element.style.display = 'none';
      });
      
      document.querySelectorAll('.read-more').forEach(function(element) {
          element.addEventListener('click', function(event) {
              event.preventDefault();
              document.querySelectorAll('.description-block .full').forEach(function(fullElement) {
                  fullElement.style.display = 'block';
              });
              document.querySelectorAll('.description-block .truncated').forEach(function(truncatedElement) {
                  truncatedElement.style.display = 'none';
              });
          });
      });
      
      document.querySelectorAll('.read-less').forEach(function(element) {
          element.addEventListener('click', function(event) {
              event.preventDefault();
              document.querySelectorAll('.description-block .full').forEach(function(fullElement) {
                  fullElement.style.display = 'none';
              });
              document.querySelectorAll('.description-block .truncated').forEach(function(truncatedElement) {
                  truncatedElement.style.display = 'block';
              });
          });
      });


}); 